
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";

// Layout
import AppLayout from "@/components/layout/AppLayout";

// Pages
import LoginPage from "@/pages/LoginPage";
import SignupPage from "@/pages/SignupPage";
import RegistrationPage from "@/pages/RegistrationPage";
import ErrorPage from "@/pages/ErrorPage";
import DashboardPage from "@/pages/DashboardPage";
import MailboxesPage from "@/pages/MailboxesPage";
import TemplatesPage from "@/pages/TemplatesPage";
import AnalyticsPage from "@/pages/AnalyticsPage";
import BillingPage from "@/pages/BillingPage";
import OpsDashboardPage from "@/pages/ops/DashboardPage";
import OpsEventsPage from "@/pages/ops/EventsPage";
import NotFound from "@/pages/NotFound";
import MsSignupPage from "./pages/MsSignupPage";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            {/* Auth Routes */}
            <Route path="/login" element={<LoginPage />} />
            <Route path="/login/callback" element={<LoginPage />} />
            <Route path="/ms-signup" element={<MsSignupPage />} />
            <Route path="/signup" element={<SignupPage />} />
            <Route path="/signup/callback" element={<SignupPage />} />
            <Route path="/signup/complete" element={<RegistrationPage />} />
            <Route path="/error" element={<ErrorPage />} />
            
            {/* App Routes */}
            <Route element={<AppLayout />}>
              {/* Root path (will redirect based on user type) */}
              <Route path="/" element={<DashboardPage />} />
              
              {/* Tenant Routes */}
              <Route path="/dashboard" element={<DashboardPage />} />
              <Route path="/mailboxes" element={<MailboxesPage />} />
              <Route path="/templates" element={<TemplatesPage />} />
              <Route path="/analytics" element={<AnalyticsPage />} />
              <Route path="/billing" element={<BillingPage />} />
              
              {/* Admin Routes */}
              <Route path="/ops" element={<OpsDashboardPage />} />
              <Route path="/ops/events" element={<OpsEventsPage />} />
            </Route>
            
            {/* Not Found */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
